import { type StyleObjectNonMulti } from '@frontend/components/src/theme/styleConfigHelpers';

import type { TextSize, TextStyleConfig } from './types';

const BASE_STYLE = {
  color: 'feature.primary',
  fontFamily: 'default',
  fontWeight: 'default',
};

const getBaseSizeStyles = (size: TextSize): StyleObjectNonMulti => ({
  fontSize: size,
  lineHeight: size,
});

const SIZES = {
  sm: getBaseSizeStyles('sm'),
  md: getBaseSizeStyles('md'),
  lg: getBaseSizeStyles('lg'),
  xl: getBaseSizeStyles('xl'),
  '2xl': getBaseSizeStyles('2xl'),
  '3xl': getBaseSizeStyles('3xl'),
};

const DEFAULT_PROPS = { size: 'md' } as const;

export const TEXT_STYLE_CONFIG: TextStyleConfig = {
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
